import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumPrinterPreference implements BaseEnumType {
  private static allValues: EnumPrinterPreference[] = []; // make sure this is top-most
  
  public static invoice = new EnumPrinterPreference(1, "Invoice", "enum_printer_preference_invoice");
  public static creditNote = new EnumPrinterPreference(2, "CreditNote", "enum_printer_preference_credit_note");
  public static deliveryNote = new EnumPrinterPreference(3, "DeliveryNote", "enum_printer_preference_delivery_note");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumPrinterPreference.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isInvoice() { return this === EnumPrinterPreference.invoice; }
  public isCreditNote() { return this === EnumPrinterPreference.creditNote; }
  public isDeliveryNote() { return this === EnumPrinterPreference.deliveryNote; }

  public static getValues(): readonly EnumPrinterPreference[] {
    return EnumPrinterPreference.allValues;
  }

  public static getValuesExcept0(): readonly EnumPrinterPreference[] {
    return EnumPrinterPreference.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumPrinterPreference {
    const found = EnumPrinterPreference.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumPrinterPreference - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumPrinterPreference): EnumPrinterPreference {
    const found = name ? EnumPrinterPreference.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumPrinterPreference - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumPrinterPreference>): boolean {
    return this.key === other?.key;
  }
}